/* eslint-disable react/display-name */
import React, { memo, useEffect, useState } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { NATIVE_APP_URL } from '../../constants';
import {
    selectViewMessageCallback,
    useStaticContext
} from '../../context/contexts/static';
import { updateShown } from '../../utils/encourageAppDownload';
import ViewMessageButton from '../ViewMessageButton';
import { useReporting } from '../../context/contexts/reporting';
import { APP_DOWNLOAD_MODAL_IS_SHOWN, MESSAGE_SENT_MODAL_IS_SHOWN, CLICKED_ON_VIEW_MESSAGE } from '../../constants/biEvents';
import paperPlane from './assets/paper-plane.svg';
import { QrCodeSection } from './QrCodeSection';
import StayInTouchTitle from './StayInTouchTitle';

import classes from './style.module.scss';

const MessageSent = ({
    showAppDownloadQr: showAppDownloadQrProp,
    drawerView,
    onClose = noop
}) => {
    const showAppDownloadQr = showAppDownloadQrProp && !drawerView;
    const { isMobile } = getContext();
    const context = useStaticContext();
    const [reportedImpression, setReportedImpression] = useState(false);
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    const handleOnViewMessageClick = () => {
        selectViewMessageCallback(context);
        sendBiEvent({ type: CLICKED_ON_VIEW_MESSAGE });
    };

    useEffect(() => {
        if (!reportedImpression) {
            if (showAppDownloadQr) {
                updateShown();
            }

            const eventType = showAppDownloadQr ? APP_DOWNLOAD_MODAL_IS_SHOWN : MESSAGE_SENT_MODAL_IS_SHOWN;
            sendBiEvent({ type: eventType });
            sendMixpanelEvent({ type: eventType });

            setReportedImpression(true);
        }
    }, [showAppDownloadQr, sendBiEvent, sendMixpanelEvent, reportedImpression]);

    const copiesSuffix = isMobile && !drawerView ? 'mobile_web' : 'web_new';
    const ctaKey = `send_message.sent_confirmation.cta.${copiesSuffix}`;
    const ctaProps = isMobile && !drawerView ? { href: NATIVE_APP_URL } : { onClick: onClose };
    const showCta = !showAppDownloadQr;
    const buttonColor = drawerView && 'black';
    return (
        <div className={classes.wrapper}>
            <div className={classNames(classes.body, { [classes.bodyMargin]: !showAppDownloadQr })}
                data-testid="message-sent-confirmation">
                <div className="flex flex-col flex-center">
                    <img src={paperPlane} className={classNames({ [classes.smallImage]: showAppDownloadQr })}/>
                    <span className={classNames('m-b-12', 'text-display-5', 'text-bold', showAppDownloadQr ? 'm-t-16' : 'm-t-24')}>
                        <I18n k="send_message.sent_confirmation.message_sent"/>
                    </span>
                    <StayInTouchTitle showAppDownloadQr={showAppDownloadQr}/>
                </div>
                {showAppDownloadQr && <QrCodeSection className="m-t-24"/>}
            </div>
            <div className={classes.footer}>
                {showCta && (
                    <Button color={buttonColor} className={classNames('m-b-8', 'm-t-12')}
                        {...ctaProps}>
                        <I18n k={ctaKey}/>
                    </Button>
                )}
                <ViewMessageButton onClick={handleOnViewMessageClick}/>
            </div>
        </div>
    );
};

MessageSent.propTypes = {
    showAppDownloadQr: PropTypes.bool,
    drawerView: PropTypes.bool,
    onClose: PropTypes.func
};

export default memo(MessageSent);
